import React from 'react';
import _ from 'lodash';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';

export enum TypeOfSelectAction {
    ADD = 'ADD',
    CLEAR = 'CLEAR',
    REMOVE = 'REMOVE',
}

const {ADD, CLEAR, REMOVE} = TypeOfSelectAction;

export interface SelectProductAction {
    type: TypeOfSelectAction;
    products?: ProductInCatalog[];
}

type Dispatch = (action: SelectProductAction) => void;
type CurrentSelectionProviderProps = {children: React.ReactNode};

export const CurrentSelectionStateContext = React.createContext<ProductInCatalog[]>([]);
const CurrentSelectionDispatchContext = React.createContext<Dispatch | undefined>(undefined);

export const selectedProductsReducer = (
    selectedProducts: ProductInCatalog[],
    action: SelectProductAction
) => {
    const {products} = action;

    switch (action.type) {
        case ADD: {
            if (products == null || products.length === 0) {
                console.error(
                    'Product Could not be Selected, no product data was given to be added to current selection'
                );
                return selectedProducts;
            }
            const mergedSelection = [...selectedProducts];
            for (const newProduct of products) {
                const currentIndex = mergedSelection.findIndex((p) => p.id === newProduct.id);
                if (currentIndex >= 0) {
                    mergedSelection[currentIndex] = newProduct;
                } else {
                    mergedSelection.push(newProduct);
                }
            }

            return mergedSelection;
        }
        case REMOVE: {
            if (products == null || products.length === 0) {
                console.error(
                    'Product Could not be Selected, no product data was given to be added to current selection'
                );
                return selectedProducts;
            }
            const productIds = products.map((p) => p.id);

            return _.filter(selectedProducts, (selectedProduct) => {
                return productIds.includes(selectedProduct.id) === false;
            });
        }
        case CLEAR: {
            return [];
        }
        default: {
            throw new Error('Unhandled action in product reducer');
        }
    }
};

export const CurrentSelectionProvider = ({children}: CurrentSelectionProviderProps) => {
    const [selectedProducts, dispatch] = React.useReducer(selectedProductsReducer, []);

    return (
        <CurrentSelectionStateContext.Provider value={selectedProducts}>
            <CurrentSelectionDispatchContext.Provider value={dispatch}>
                {children}
            </CurrentSelectionDispatchContext.Provider>
        </CurrentSelectionStateContext.Provider>
    );
};

export const DispatchCurrentSelectionAction = () => {
    const context = React.useContext(CurrentSelectionDispatchContext);
    if (context === undefined) {
        throw new Error('useCurrentSelectionDispatch must be within CurrentSelectionProvider');
    }
    return context;
};
